/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 4168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export TTNHeader */
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2148);
/* harmony import */ var _ttn_header_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8980);


class TTNHeader extends lit_element__WEBPACK_IMPORTED_MODULE_0__/* .LitElement */ .oi {
  static get styles() {
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__/* .unsafeCSS */ .$m)(_ttn_header_styl__WEBPACK_IMPORTED_MODULE_1__/* ["default"].toString */ .Z.toString());
  }
  static get properties() {
    return {
      user: {
        type: Object,
        attribute: 'user'
      },
      loginPath: {
        type: String,
        attribute: 'login-path'
      },
      logoutPath: {
        type: String,
        attribute: 'logout-path'
      },
      signUpPath: {
        type: String,
        attribute: 'signup-path'
      },
      disableFetch: {
        type: Boolean,
        attribute: 'disable-fetch'
      }
    };
  }
  constructor() {
    super();
    this.loginPath = `/get-started?login`;
    this.logoutPath = `/logout/`;
    this.signUpPath = `/get-started`;
    this.user = undefined;
    this.disableFetch = false;
    this.forum = {
      url: `/forum`,
      title: 'Forum'
    };
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.disableFetch) {
      fetch(`/api/user/me`, {
        credentials: 'include'
      }).then(data => data.json()).then(data => {
        this.user = data.me;
      }).catch(e => {
        this.user = undefined;
      });
    }
    if (window.location.pathname.startsWith('/country/japan')) {
      this.forum.url = 'https://www.thethingsnetwork.jp/forum';
      this.forum.title = 'フォーラム';
    }
  }
  render() {
    return lit_element__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`
      <ttui-header>
        <div slot="middle">
          <ttui-nav>
            <nav-item>
              <a slot="nav_item__link" href="/docs">Learn</a>
            </nav-item>
            <nav-dropdown name="Hardware">
              <nav-dropdown-item>
                <a slot="nav_dropdown__link" href="/device-repository">Devices</a>
              </nav-dropdown-item>
              <nav-dropdown-item>
                <a slot="nav_dropdown__link" href="https://www.thethingsshop.com/">
                  The Things Shop
                </a>
              </nav-dropdown-item>
            </nav-dropdown>
            <nav-item>
              <a slot="nav_item__link" href="${this.forum.url}" target="_blank"
                >${this.forum.title}</a
              >
            </nav-item>
            <nav-item>
              <a slot="nav_item__link" href="/community">Communities</a>
            </nav-item>
            <nav-item>
              <a slot="nav_item__link" href="https://www.thethingsconference.com" target="_blank"
                >Conference</a
              >
            </nav-item>
            ${this.user && lit_element__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<nav-item mobile-only>
                <a slot="nav_item__link" href="https://console.cloud.thethings.network/"
                  >Console</a
                ></nav-item
              ><nav-item mobile-only>
                <a slot="nav_item__link" href="${this.logoutPath}">Log Out</a>
              </nav-item>`}
            <nav-item>
              <a
                slot="nav_item__link"
                href="https://thethingsindustries.com"
                class="theme-tti ttui-btn ttui-btn--primary invert"
              >
                Enterprise
              </a>
            </nav-item>
          </ttui-nav>
        </div>
        <div slot="right">
          ${this.user ? lit_element__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<user-menu user>
                <ttui-nav slot="menu-user">
                  <nav-dropdown
                    name="${this.user ? `${this.user.username}` : ''}"
                    image="${this.user ? `https://id.thethingsnetwork.org/pictures/${this.user.username}/thumbnail` : ''}"
                    align="right"
                    desktop-show-icon
                    desktop-disable-hover
                    mobile-img-only
                    mobile-disabled
                    img-round
                  >
                    <nav-dropdown-item>
                      <a
                        slot="nav_dropdown__link"
                        href="${this.user ? `/u/${this.user.username}` : ''}"
                        >My Profile</a
                      >
                    </nav-dropdown-item>
                    <nav-dropdown-item>
                      <a slot="nav_dropdown__link" href="https://console.cloud.thethings.network/"
                        >Console</a
                      >
                    </nav-dropdown-item>
                    <nav-dropdown-item>
                      <a slot="nav_dropdown__link" href="${this.logoutPath}">Log Out</a>
                    </nav-dropdown-item>
                  </nav-dropdown>
                </ttui-nav>
              </user-menu>` : lit_element__WEBPACK_IMPORTED_MODULE_0__/* .html */ .dy`<user-menu
                login-path="${this.loginPath}"
                signup-path="${this.signUpPath}"
              ></user-menu>`}
        </div>
      </ttui-header>
    `;
  }
}
window.customElements.define('ttn-header', TTNHeader);

/***/ }),

/***/ 8980:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_node_modules_normalize_css_normalize_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5735);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_node_modules_suitcss_base_lib_base_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4212);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1667);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _assets_icons_tti_list_tick_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2131);
/* harmony import */ var _assets_icons_generic_list_tick_transparent_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7240);
/* harmony import */ var _assets_icons_generic_list_tick_green_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6777);
/* harmony import */ var _assets_icons_generic_list_cross_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8568);
/* harmony import */ var _assets_icons_generic_list_cross_transparent_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8717);
/* harmony import */ var _assets_the_things_industries_logos_horizontal_logo_tti_horizontal_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3246);
/* harmony import */ var _assets_the_things_industries_logos_horizontal_logo_tti_horizontal_white_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7486);
/* harmony import */ var _assets_the_things_industries_logos_profile_picture_tti_icon_color_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6893);
/* harmony import */ var _assets_the_things_industries_logos_profile_picture_tti_icon_white_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9551);
/* harmony import */ var _assets_the_things_industries_logos_square_logo_tti_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1216);
/* harmony import */ var _assets_the_things_industries_logos_square_logo_tti_white_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9448);
// Imports















var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_node_modules_normalize_css_normalize_css__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_node_modules_suitcss_base_lib_base_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_icons_tti_list_tick_svg__WEBPACK_IMPORTED_MODULE_4__);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_icons_generic_list_tick_transparent_svg__WEBPACK_IMPORTED_MODULE_5__);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_icons_generic_list_tick_green_svg__WEBPACK_IMPORTED_MODULE_6__);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_icons_generic_list_cross_svg__WEBPACK_IMPORTED_MODULE_7__);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_icons_generic_list_cross_transparent_svg__WEBPACK_IMPORTED_MODULE_8__);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_the_things_industries_logos_horizontal_logo_tti_horizontal_svg__WEBPACK_IMPORTED_MODULE_9__);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_the_things_industries_logos_horizontal_logo_tti_horizontal_white_svg__WEBPACK_IMPORTED_MODULE_10__);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_the_things_industries_logos_profile_picture_tti_icon_color_svg__WEBPACK_IMPORTED_MODULE_11__);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_the_things_industries_logos_profile_picture_tti_icon_white_svg__WEBPACK_IMPORTED_MODULE_12__);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_the_things_industries_logos_square_logo_tti_svg__WEBPACK_IMPORTED_MODULE_13__);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_3___default()(_assets_the_things_industries_logos_square_logo_tti_white_svg__WEBPACK_IMPORTED_MODULE_14__);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a{color:inherit;text-decoration:inherit}button,input,optgroup,select,textarea{padding:0;line-height:inherit;color:inherit}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}html:not(.ttui-disable-typography){font-size:16px;height:100%;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol';line-height:var(--lh-m)}@media screen and (max-width:620px){html:not(.ttui-disable-typography){font-size:14px}}html:not(.ttui-disable-typography):not(.ttui-disable-font-smoothing){-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}h1,h2,h3,h4,h5{font-family:'ITC Avant Garde Pro',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'}h1{font-size:var(--fs-xl3);line-height:var(--lh-xs)}h2{font-size:var(--fs-xxl);line-height:var(--lh-xs)}h3{font-size:var(--fs-l);line-height:var(--lh-s)}h4{font-size:var(--fs-m);line-height:var(--lh-s)}h5{font-size:var(--fs-s);line-height:var(--lh-m)}.ttui-btn{padding:var(--cs-s) var(--cs-l);border:.5px solid;border-radius:var(--br-m);cursor:pointer;text-decoration:none;text-align:center;line-height:var(--lh-xs);letter-spacing:var(--lsp-l);font-size:var(--fs-m);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ttui-btn:hover{-webkit-transition:background-color 0.2s, border-color 0.2s, color 0.2s;-moz-transition:background-color 0.2s, border-color 0.2s, color 0.2s;-o-transition:background-color 0.2s, border-color 0.2s, color 0.2s;-ms-transition:background-color 0.2s, border-color 0.2s, color 0.2s;transition:background-color 0.2s, border-color 0.2s, color 0.2s}.ttui-btn--primary{border:.5px solid var(--c-interactive-03);color:#fff;background-color:var(--c-interactive-03)}.ttui-btn--primary:hover{background-color:var(--c-interactive-02)}.ttui-btn--primary.invert{color:var(--c-interactive-03);background-color:var(--c-background-02);border:.5px solid var(--c-background-02)}.ttui-btn--primary.invert:hover{background-color:var(--c-background-01);border:.5px solid var(--c-background-01)}.ttui-btn--primary.danger,.ttui-btn--primary.error{color:var(--c-white);background-color:var(--c-red-error-500);border:.5px solid var(--c-red-error-500)}.ttui-btn--primary.danger:hover,.ttui-btn--primary.error:hover{background-color:var(--c-red-error-600);border:.5px solid var(--c-red-error-600)}.ttui-btn--primary.warning{color:var(--c-white);background-color:var(--c-orange-warning-500);border:.5px solid var(--c-orange-warning-500)}.ttui-btn--primary.warning:hover{background-color:var(--c-orange-warning-600);border:.5px solid var(--c-orange-warning-600)}.ttui-btn--primary.validation{color:var(--c-white);background-color:var(--c-green-validation-500);border:.5px solid var(--c-green-validation-500)}.ttui-btn--primary.validation:hover{background-color:var(--c-green-validation-600);border:.5px solid var(--c-green-validation-600)}.ttui-btn--primary.subtle{color:var(--c-white);background-color:var(--c-grey-400);border:.5px solid var(--c-grey-400)}.ttui-btn--primary.subtle:hover{background-color:var(--c-grey-500);border:.5px solid var(--c-grey-500)}.ttui-btn--primary.disabled{color:var(--c-grey-500);background-color:var(--c-grey-100);border:.5px solid var(--c-grey-100);cursor:default}.ttui-btn--primary.disabled:hover{pointer-events:none}.ttui-btn--primary.underline{text-decoration:underline}.ttui-btn--primary.inline{padding:var(--cs-xxs) var(--cs-xs);border-radius:5px}.ttui-btn--primary.default{background-color:var(--c-white);border:0;color:var(--c-grey-900)}.ttui-btn--primary.default:hover{background-color:var(--c-grey-200)}.ttui-btn--secondary{color:var(--c-interactive-03);background-color:transparent;border:.5px solid var(--c-interactive-03)}.ttui-btn--secondary:hover{color:var(--c-white);background-color:var(--c-interactive-02);border:.5px solid var(--c-interactive-02)}.ttui-btn--secondary.invert{color:var(--c-background-02);background-color:transparent;border:.5px solid var(--c-background-02)}.ttui-btn--secondary.invert:hover{color:var(--c-interactive-02);background-color:var(--c-background-01);border:.5px solid var(--c-background-01)}.ttui-btn--secondary.danger,.ttui-btn--secondary.error{color:var(--c-red-error-500);background-color:transparent;border:.5px solid var(--c-red-error-500)}.ttui-btn--secondary.danger:hover,.ttui-btn--secondary.error:hover{color:var(--c-white);background-color:var(--c-red-error-600);border:.5px solid var(--c-red-error-600)}.ttui-btn--secondary.warning{color:var(--c-orange-warning-500);background-color:transparent;border:.5px solid var(--c-orange-warning-500)}.ttui-btn--secondary.warning:hover{color:var(--c-white);background-color:var(--c-orange-warning-600);border:.5px solid var(--c-orange-warning-600)}.ttui-btn--secondary.validation{color:var(--c-green-validation-500);background-color:transparent;border:.5px solid var(--c-green-validation-500)}.ttui-btn--secondary.validation:hover{color:var(--c-white);background-color:var(--c-green-validation-600);border:.5px solid var(--c-green-validation-600)}.ttui-btn--secondary.subtle{color:var(--c-grey-400);background-color:transparent;border:.5px solid var(--c-grey-400)}.ttui-btn--secondary.subtle:hover{color:var(--c-white);background-color:var(--c-grey-500);border:.5px solid var(--c-grey-500)}.ttui-btn--secondary.disabled{color:var(--c-grey-200);background-color:transparent;border:.5px solid var(--c-grey-200)}.ttui-btn--secondary.disabled:hover{pointer-events:none}.ttui-btn--secondary.underline{text-decoration:underline}.ttui-btn--secondary.inline{padding:var(--cs-xxs) var(--cs-xs);border-radius:5px}.ttui-btn--tertiary{color:var(--c-interactive-03);background-color:transparent;border:1px solid transparent}.ttui-btn--tertiary:hover{background-color:var(--c-background-02)}.ttui-btn--tertiary.invert{color:var(--c-background-02)}.ttui-btn--tertiary.invert:hover{color:var(--c-interactive-03);background-color:var(--c-background-02)}.ttui-btn--tertiary.danger,.ttui-btn--tertiary.error{color:var(--c-red-error-500)}.ttui-btn--tertiary.danger:hover,.ttui-btn--tertiary.error:hover{background-color:var(--c-red-error-100)}.ttui-btn--tertiary.warning{color:var(--c-orange-warning-500)}.ttui-btn--tertiary.warning:hover{background-color:var(--c-orange-warning-100)}.ttui-btn--tertiary.validation{color:var(--c-green-validation-500)}.ttui-btn--tertiary.validation:hover{background-color:var(--c-green-validation-100)}.ttui-btn--tertiary.subtle{color:var(--c-grey-500)}.ttui-btn--tertiary.subtle:hover{background-color:var(--c-grey-200)}.ttui-btn--tertiary.disabled{color:var(--c-grey-400)}.ttui-btn--tertiary.disabled:hover{cursor:default;background-color:transparent}.ttui-btn--tertiary.underline{text-decoration:underline}.ttui-btn--tertiary.inline{padding:var(--cs-xxs) var(--cs-xs);border-radius:5px}.ttui-btn-cta{font-family:'Inter';border-radius:var(--br-xxl);padding:var(--cs-m) var(--cs-xl);cursor:pointer;text-decoration:none;text-align:center;line-height:var(--lh-xs);letter-spacing:var(--lsp-l);font-size:var(--fs-m);font-weight:var(--fw-bold);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-transition:background-color 0.2s, border-color 0.2s, color 0.2s;-moz-transition:background-color 0.2s, border-color 0.2s, color 0.2s;-o-transition:background-color 0.2s, border-color 0.2s, color 0.2s;-ms-transition:background-color 0.2s, border-color 0.2s, color 0.2s;transition:background-color 0.2s, border-color 0.2s, color 0.2s}.ttui-btn-cta--s{font-size:var(--fs-s);padding:var(--cs-s) var(--cs-l)}.ttui-btn-cta--l{font-size:var(--fs-l);padding:var(--cs-l) var(--cs-xl3)}.ttui-btn-cta--primary{background-color:var(--c-interactive-03);border:.5px solid var(--c-interactive-03);color:var(--c-text-06)}.ttui-btn-cta--primary:hover{background-color:var(--c-interactive-02)}.ttui-btn-cta--primary.invert{color:var(--c-text-02);border:1px solid var(--c-line-06);background-color:var(--c-interactive-05)}.ttui-btn-cta--primary.invert:hover{background-color:var(--c-bone)}.ttui-btn-cta--block{display:block;width:fit-content}.ttui-btn-cta--block.ttui-btn-cta--center-h,.ttui-btn-cta--block.ttn-btn--center-h{margin:auto}.theme-tti{--c-background-01:var(--c-tti-primary-200);--c-background-02:var(--c-tti-primary-100);--c-background-03:var(--c-tti-primary-050);--c-background-04:var(--c-white);--c-background-05:var(--c-tti-primary-dark);--c-background-06:var(--c-tti-primary-main);--c-interactive-01:var(--c-tti-primary-dark);--c-interactive-02:var(--c-tti-primary-600);--c-interactive-03:var(--c-tti-primary-main);--c-interactive-04:var(--c-tti-primary-200);--c-interactive-05:var(--c-white);--c-interactive-06:var(--c-grey-900);--c-text-01:var(--c-tti-primary-dark);--c-text-02:var(--c-tti-primary-main);--c-text-03:var(--c-grey-900);--c-text-04:var(--c-grey-500);--c-text-05:var(--c-grey-300);--c-text-06:var(--c-white);--c-line-01:var(--c-tti-primary-main);--c-line-02:var(--c-tti-primary-200);--c-line-03:var(--c-grey-400);--c-line-04:var(--c-grey-500);--c-line-05:var(--c-grey-300);--c-line-06:var(--c-grey-200);--c-line-07:var(--c-white);--c-icon-01:var(--c-tti-primary-dark);--c-icon-02:var(--c-tti-primary-main);--c-icon-03:var(--c-grey-900);--c-icon-04:var(--c-grey-500)}.theme-tti{--icon-tick:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");--icon-tick-transparent:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");--icon-tick-green:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ");--icon-cross:url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ");--icon-cross-transparent:url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ")}.theme-tti{--lg-horizontal:url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + ");--lg-horizontal-white:url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + ");--lg-profile:url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + ");--lg-profile-white:url(" + ___CSS_LOADER_URL_REPLACEMENT_8___ + ");--lg-square:url(" + ___CSS_LOADER_URL_REPLACEMENT_9___ + ");--lg-square-white:url(" + ___CSS_LOADER_URL_REPLACEMENT_10___ + ")}", ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8717:
/***/ ((module) => {

module.exports = "data:image/svg+xml,%3csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='7.5' cy='7.5' r='7' stroke='white'/%3e %3cpath d='M5 5L10 10' stroke='white' stroke-linecap='round'/%3e %3cpath d='M10 5L5 10' stroke='white' stroke-linecap='round'/%3e %3c/svg%3e";

/***/ }),

/***/ 8568:
/***/ ((module) => {

module.exports = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='8' cy='8' r='7.625' stroke='%23F9595A' stroke-width='0.75'/%3e %3cpath d='M5 5L11 11' stroke='%23F9595A' stroke-linecap='round'/%3e %3cpath d='M11 5L5 11' stroke='%23F9595A' stroke-linecap='round'/%3e %3c/svg%3e";

/***/ }),

/***/ 6777:
/***/ ((module) => {

module.exports = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='8' cy='8' r='7.625' stroke='%2324C833' stroke-width='0.75'/%3e %3cpath d='M11 6L7 10L5 8' stroke='%2324C833' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";

/***/ }),

/***/ 7240:
/***/ ((module) => {

module.exports = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='8' cy='8' r='7.625' stroke='white' stroke-width='0.75'/%3e %3cpath d='M11 6L7 10L5 8' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";

/***/ }),

/***/ 2131:
/***/ ((module) => {

module.exports = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='8' cy='8' r='7.625' stroke='%230047FF' stroke-width='0.75'/%3e %3cpath d='M11 6L7 10L5 8' stroke='%230047FF' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";

/***/ }),

/***/ 7486:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "assets/4e574c12065aa34d1c96.svg";

/***/ }),

/***/ 3246:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "assets/9f8f7e651b3fba3277b0.svg";

/***/ }),

/***/ 6893:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "assets/b347479d971bcee076f2.svg";

/***/ }),

/***/ 9551:
/***/ ((module) => {

module.exports = "data:image/svg+xml,%3csvg viewBox='0 0 500 500' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M461.667 225C482.838 225 500 242.162 500 263.333v93.334c0 21.17-17.162 38.333-38.333 38.333s-38.334-17.163-38.334-38.333v-93.334c0-21.171 17.163-38.333 38.334-38.333Zm-325-66.667c23.932 0 43.333 19.401 43.333 43.334v150C180 375.599 160.599 395 136.667 395c-23.933 0-43.334-19.401-43.334-43.333v-150c0-23.933 19.401-43.334 43.334-43.334ZM38.333 225c21.171 0 38.334 17.162 38.334 38.333v93.334c0 21.17-17.163 38.333-38.334 38.333C17.163 395 0 377.837 0 356.667v-93.334C0 242.162 17.162 225 38.333 225Zm325-50c23.933 0 43.334 19.401 43.334 43.333v133.334c0 23.932-19.401 43.333-43.334 43.333C339.401 395 320 375.599 320 351.667V218.333C320 194.401 339.401 175 363.333 175ZM250 105c29.455 0 53.333 23.878 53.333 53.333v183.334C303.333 371.122 279.455 395 250 395s-53.333-23.878-53.333-53.333V158.333C196.667 128.878 220.545 105 250 105Z' fill='white'/%3e%3c/svg%3e";

/***/ }),

/***/ 9448:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "assets/edc19b285d497a369d8f.svg";

/***/ }),

/***/ 1216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "assets/d40c0f8ea4207ba1c254.svg";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	(() => {
/******/ 		__webpack_require__.j = 573;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "https://ttui.thethingsindustries.com/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			573: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk_tti_design"] = self["webpackChunk_tti_design"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [253], () => (__webpack_require__(4168)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;